import React from 'react';
import PropTypes from 'prop-types';
import { css, StyleSheet } from 'aphrodite';
import classNames from 'classnames';
import { appendCdnHostName } from '../../../utility/geoUtils';

const illustrations = {
  critical: appendCdnHostName('/paypal-ui/illustrations/svg/critical.svg'),
  'more-info': appendCdnHostName('/paypal-ui/illustrations/svg/more-info.svg'),
  'credit-cards': appendCdnHostName(
    '/paypal-ui/illustrations/svg/credit-cards.svg'
  ),
  success: appendCdnHostName('/paypal-ui/illustrations/svg/success.svg'),
  warning: appendCdnHostName('/paypal-ui/illustrations/svg/warning.svg'),
  activity: appendCdnHostName('/paypal-ui/illustrations/svg/activity.svg'),
};

const STYLES = StyleSheet.create({
  large: {
    width: 96,
  },
  small: {
    width: 72,
  },
});

export default function Illustration({
  type,
  size = 'large',
  className,
  ariaHidden,
  ...rest
}) {
  const classes = classNames(className, {
    [css(STYLES.large)]: size === 'large',
    [css(STYLES.small)]: size === 'small',
  });

  return (
    <img
      src={illustrations[type]}
      className={classes}
      {...rest}
      aria-hidden={ariaHidden || false}
    />
  );
}

Illustration.propTypes = {
  type: PropTypes.string,
  size: PropTypes.string,
  className: PropTypes.string,
  ariaHidden: PropTypes.bool,
};
